import { CommApiInstance } from "Utils/CommApiInstance";

const MembPasswdChngApi = async (
    loginId:string,
    password:string,
    cptchTkn:string,
    idntMthdCd:string,
    emlAthnCd:string|null,
) => {
    
    return await CommApiInstance.post(`memb/passwd/chng`,{
        apiBody:{
            loginId:loginId,
            passwd:password,
            cptchTkn:cptchTkn,
            idntMthdCd:idntMthdCd,
            athnNo:emlAthnCd,
        },
    })
    .then((Resp) => Resp.data);
    
}
export default MembPasswdChngApi;